export default "/static/dashboard/build/app/img/v2/baf2bf641b7dbb03a308c9b024b5dd7e.png";